import { memo } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Flag, PlayCircle } from "lucide-react";
import type { VirtualNodeData } from "./flow.utils";

function WorkflowVirtualNodeComponent({ data }: NodeProps) {
  const nodeData = data as unknown as VirtualNodeData;
  const isStart = nodeData.kind === "start";
  const Icon = isStart ? PlayCircle : Flag;

  return (
    <>
      {!isStart && <Handle type="target" position={Position.Left} className="!bg-gray-400" />}
      <div className="flex h-[52px] w-[132px] items-center gap-2 rounded-full border border-dashed border-gray-300 bg-white px-4 text-gray-700 shadow-sm dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200">
        <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
          <Icon className="size-4" />
        </span>
        <span className="text-xs font-semibold uppercase tracking-wide">{nodeData.label}</span>
      </div>
      {isStart && <Handle type="source" position={Position.Right} className="!bg-gray-400" />}
    </>
  );
}

export default memo(WorkflowVirtualNodeComponent);
